(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // StickyHeader custom element for Shopify header
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.querySelector('.header');
      this.lastScrollY = window.scrollY;
      this.defaultPosition = this.dataset.headerPosition;

      this.headerIsAlwaysSticky = false;
      this.headerBounds = {};

      this.setHeaderHeight();

      // Update header height on viewport changes
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const currentScrollY = window.scrollY;
      const stickyType = this.dataset.stickyType;

      if (stickyType === 'none') return;

      this.header.style.transition = 'transform 0.3s ease';

      if (stickyType === 'always') {
        this.style.position = 'fixed';
        this.style.top = '0';
        this.style.left = '0';
        this.style.right = '0';
        this.style.zIndex = 'auto';
        this.header.style.transform = 'translateY(0)';

        if (currentScrollY > 0) {
          this.header.style.backdropFilter = 'blur(12px)';
          this.header.style.background = 'rgba(0, 0, 0, 0.8)';
        } else {
          this.header.style.backdropFilter = '';
          this.header.style.background = '';
        }
      } else if (stickyType === 'on-scroll-up') {
        // At the very top: show header, remove blur
        if (currentScrollY <= 0) {
          this.header.style.transform = 'translateY(0)';
          this.header.style.backdropFilter = '';
          this.header.style.background = '';
          this.style.position = '';
        }
        // Scrolling DOWN: hide header
        else if (currentScrollY > this.lastScrollY && currentScrollY > 100) {
          this.header.style.transform = 'translateY(-100%)';
          this.style.position = 'fixed';
          this.style.top = '0';
          this.style.left = '0';
          this.style.right = '0';
          this.style.zIndex = 'auto';
        }
        // Scrolling UP: show header with blur
        else if (currentScrollY < this.lastScrollY) {
          this.header.style.transform = 'translateY(0)';
          this.header.style.backdropFilter = 'blur(12px)';
          this.header.style.background = 'rgba(0, 0, 0, 0.8)';
          this.style.position = 'fixed';
          this.style.top = '0';
          this.style.left = '0';
          this.style.right = '0';
          this.style.zIndex = 'auto';
        }
      } else if (stickyType === 'reduce-logo-size') {
        this.style.position = 'fixed';
        this.style.top = '0';
        this.style.left = '0';
        this.style.right = '0';
        this.style.zIndex = 'auto';

        if (currentScrollY > 100) {
          this.classList.add('scrolled-past-header');
          this.header.style.backdropFilter = 'blur(12px)';
          this.header.style.background = 'rgba(0, 0, 0, 0.8)';
        } else {
          this.classList.remove('scrolled-past-header');
          this.header.style.backdropFilter = '';
          this.header.style.background = '';
        }
      }

      this.lastScrollY = currentScrollY;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
